import styled from "styled-components";

const Container = styled.div`
    display: flex;
    justify-content: center;
    border-top: 1px solid gray;
`;

const Footer = () => {
    return (
        <Container>
            <p>Copyright &copy; {new Date().getFullYear()} Favaloro</p>
        </Container>
    );
};

export default Footer;
